import {
    OfficialGrade,
    OfficialGradeTree,
} from 'routes/HumanResourcesModule/Settings/HrGrade/helpers/type';

const filterOfficialGrade = (
    officialGrade: OfficialGrade,
    filterValue: string,
) => officialGrade.grade.toLowerCase().includes(filterValue.toLowerCase());

const filterOfficialGradeTree = (
    officialGradeTree: OfficialGradeTree,
    filterValue: string,
): boolean =>
    officialGradeTree.filiere
        .toLowerCase()
        .includes(filterValue.toLowerCase()) ||
    officialGradeTree.children.some((child) =>
        filterOfficialGrade(child, filterValue),
    );

export const filterOfficialGradesTree = (
    officialGradesTree: OfficialGradeTree[],
    filterValue: string,
    setExpanded: React.Dispatch<React.SetStateAction<string[]>>,
): OfficialGradeTree[] => {
    if (filterValue === '') {
        setExpanded([]);
        return officialGradesTree;
    }

    const filteredOfficialGradesTree = officialGradesTree
        .filter((el) => filterOfficialGradeTree(el, filterValue))
        .map((el) => ({
            ...el,
            children: el.children.filter((child) =>
                filterOfficialGrade(child, filterValue),
            ),
        }));

    const expandedFiliere = filteredOfficialGradesTree
        .filter((el) => el.children.length > 0)
        .map((el) => `filiere-${el.filiere}`);

    setExpanded(expandedFiliere);

    return filteredOfficialGradesTree;
};

export const formatOfficialGradesTree = (
    officialGrades: OfficialGrade[],
): OfficialGradeTree[] => {
    // Group OfficialGrades by filiere
    const filiereGroupedOfficialGrades: Record<string, OfficialGrade[]> =
        officialGrades.reduce(
            (
                acc: Record<string, OfficialGrade[]>,
                officialGrade: OfficialGrade,
            ) => {
                (acc[officialGrade.filiere] =
                    acc[officialGrade.filiere] || []).push(officialGrade);
                return acc;
            },
            {},
        );

    // Convert filiereGroupedOfficialGrades to an array of OfficialGradeTree
    const officialGradesTree: OfficialGradeTree[] = Object.entries(
        filiereGroupedOfficialGrades,
    )
        .map(([filiere, grades]) => {
            // Collect all unique cadreEmploi values from the grades
            const cadreEmploiSet = new Set(
                grades.map((grade) => grade.cadreEmploi),
            );
            const cadreEmploi = Array.from(cadreEmploiSet);

            return {
                filiere,
                cadreEmploi,
                children: grades.sort((a, b) => a.grade.localeCompare(b.grade)),
            };
        })
        .sort((a, b) => a.filiere.localeCompare(b.filiere));

    return officialGradesTree;
};
